import React, { useEffect } from 'react';
import { Form } from 'antd';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import ClassSeatsNumberInput from '../../../../../inputs/classSeatsNumberInput/ClassSeatsNumberInput';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function ChooseClasses({
  direction = 'departure',
  typeBooking = true,
  bookClassesForm,
}) {
  const { bookingData } = useBooking();
  const { trans } = useTranslation();
  const classes = Form.useWatch('classes', bookClassesForm);
  const amountOfClasses = classes?.reduce((acc, cur) => acc + (cur.amount ? cur.amount * 1 : 0), 0);

  useEffect(() => {
    const bookClasses = [];
    if (Array.isArray(
      bookingData?.[direction]
        ?.chosenAvailableSeatsClasses,
    )) {
      bookingData
        ?.[direction]
        ?.chosenAvailableSeatsClasses
        ?.forEach(({ seatClass, priceOfSeats }) => {
          bookClasses.push({
            id: seatClass?.id,
            name: seatClass?.name,
            price: priceOfSeats?.amount,
            amount: '0',
          });
        });
    }
    if (Array.isArray(
      bookingData?.[direction]
        ?.chosenAvailableSeatsGroups,
    )) {
      bookingData
        ?.[direction]
        ?.chosenAvailableSeatsGroups
        ?.forEach(({ seatClass, priceOfSeats, seatGroupProperty }) => {
          bookClasses.push({
            id: seatClass?.id,
            name: seatClass?.name,
            price: priceOfSeats?.amount,
            amount: '0',
            seatGroupProperty,
          });
        });
    }
    bookClassesForm.setFieldValue('classes', bookClasses);
  }, [JSON.stringify(bookingData)]);

  const checkClassMoreAmountAvailable = (index, currentSeatClass) => {
    if (!currentSeatClass?.seatGroupProperty) {
      const availableSeatClass = bookingData?.[direction]?.chosenAvailableSeatsClasses?.find(
        (seatClass) => seatClass?.seatClass?.id === classes?.[index].id,
      );

      if (availableSeatClass) {
        return availableSeatClass?.availableNumberOfSeats > classes?.[index].amount;
      }
    }

    const availableSeatGroup = bookingData?.[direction]?.chosenAvailableSeatsGroups?.find(
      (seatGroup) => seatGroup?.seatClass?.id === classes?.[index].id,
    );

    return availableSeatGroup?.availableNumberOfSeats > classes?.[index].amount;
  };

  return (
    <Form form={bookClassesForm} layout="vertical" className="flex flex-col gap-5">
      {(amountOfClasses < 10 && typeBooking) && (
      <h3 className="font-big-bold text-primary">
        {trans('group_booking_seats_minimum')}
      </h3>
      )}
      <div className="w-full h-[1px] bg-gray-semi-light-gr" />
      <Form.List
        name="classes"
      >
        {(fields) => (
          <div className="grid grid-cols-1 2xl:grid-cols-2 gap-4">
            {fields.map((field, index) => {
              const classId = `${classes[index].id}${classes[index].seatGroupProperty?.id ? `-${classes[index].seatGroupProperty.id}` : ''}`;
              return (
                <ClassSeatsNumberInput
                  key={classId}
                  seatClassId={classId}
                  className="col-span-1"
                  label={classes[index].name}
                  price={classes[index].price}
                  form={bookClassesForm}
                  name={[index, 'amount']}
                  watchName={['classes', index, 'amount']}
                  disabled={(amountOfClasses >= 9 && !typeBooking)
                      || !checkClassMoreAmountAvailable(index, classes[index])}
                />
              );
            })}
          </div>
        )}
      </Form.List>
    </Form>
  );
}

export default ChooseClasses;
